import { useEffect } from 'react';
import useAxios from '../useAxios';
import { API_ENDPOINTS } from '../endpoints';
import { RefreshTokenResponse } from '../../types/Auth';

// Custom hook for finding user by username
const useFindUsername = (username: string) => {
  const { data, error, loading, fetchData } = useAxios<any>(
    `${API_ENDPOINTS.auth.FIND_USERNAME}/${username}`, // Updated endpoint name
    'GET',
  );

  useEffect(() => {
    if (username) {
      fetchData();
    }
  }, [username, fetchData]);

  return { data, error, loading };
};

// Logout API function
export const logoutUser = async (
  userId: string,
  token: string,
  refreshToken?: string,
  sessionKey?: string,
) => {
  const response = await fetch(`${process.env.NX_PUBLIC_API_URL}${API_ENDPOINTS.auth.LOGOUT}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userId,
      token,
      refreshToken: refreshToken || null,
      sessionKey: sessionKey || null,
    }),
  });

  if (!response.ok) {
    let errorMessage = 'Logout failed';
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorData.error || errorMessage;
    } catch {
      errorMessage = `Logout failed with status: ${response.status} ${response.statusText}`;
    }
    throw new Error(errorMessage);
  }

  return response.json();
};

export const refreshAccessToken = async (
  refreshToken: string,
  sessionKey?: string,
): Promise<RefreshTokenResponse> => {
  const response = await fetch(`${process.env.NX_PUBLIC_API_URL}${API_ENDPOINTS.auth.REFRESH_TOKEN}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      refreshToken,
      sessionKey: sessionKey || null,
    }),
  });

  if (!response.ok) {
    let errorMessage = 'Token refresh failed';
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorData.error || errorMessage;
    } catch {
      errorMessage = `Token refresh failed with status: ${response.status} ${response.statusText}`;
    }
    throw new Error(errorMessage);
  }

  return response.json();
};

export default useFindUsername;
